<template>
  <div
    :class="['zg-messaging-inline-text', {
      [`zg-messaging-inline-text--background-${background}`]: background,
      [`zg-messaging-inline-text--padding-${padding}`]: padding
    }]"
  >
    <zg-icon
      :icon="icon"
      size="small"
    />

    <div class="content">
      <slot />
    </div>
  </div>
</template>

<script>
  import ZgIcon from '../ZgIcon/ZgIcon.vue'

  export default {
    name: 'ZgMessagingInlineText',
    components: {
      ZgIcon
    },
    props: {
      type: {
        type: String,
        required: false,
        default: 'info',
        validator: value => [
          'info',
          'confirmation',
          'warning',
          'error'
        ].includes(value)
      },
      background: {
        type: String,
        required: false,
        default: 'beige',
        validator: value => [
          'none',
          'beige',
          'white'
        ].includes(value)
      },
      padding: {
        type: String,
        required: false,
        default: 'small',
        validator: value => [
          'xsmall',
          'small',
          'medium'
        ].includes(value)
      }
    },
    computed: {
      icon () {
        return {
          info: 'info',
          confirmation: 'check-circle',
          warning: 'warning',
          error: 'error'
        }[this.type]
      }
    }
  }
</script>

<style lang="scss" scoped>
  .zg-messaging-inline-text {
    display: flex;
    gap: rem(12px);
    border-radius: radius(small);

    ::v-deep svg {
      fill: color(black);
      flex-shrink: 0;
    }
  }

  // ? ----------------------------------------------------------------------
  // background
  // ? ----------------------------------------------------------------------

  .zg-messaging-inline-text--background-none {
    background-color: transparent;
  }

  .zg-messaging-inline-text--background-beige {
    background-color: color(beige);
  }

  .zg-messaging-inline-text--background-white {
    background-color: color(white);
  }

  // ? ----------------------------------------------------------------------
  // padding
  // ? ----------------------------------------------------------------------

  .zg-messaging-inline-text--padding-xsmall {
    padding: rhythm(xsmall);
  }

  .zg-messaging-inline-text--padding-small {
    padding: rhythm(small);
  }

  .zg-messaging-inline-text--padding-medium {
    padding: rhythm(medium);
  }
</style>
